import React from "react";

const PremiumModal = ({ isOpen, onClose, onGoToBilling }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      {/* Overlay con desenfoque */}
      <div
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm animate-fadeIn"
        onClick={onClose}
      />

      {/* Contenido del Modal */}
      <div className="relative bg-white w-full max-w-sm rounded-3xl p-8 shadow-2xl animate-scaleIn text-center">
        <div className="w-20 h-20 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center text-4xl mx-auto mb-6">
          🔒
        </div>

        <h2 className="text-2xl font-black text-slate-800 mb-2">
          Función Premium
        </h2>

        <p className="text-slate-600 mb-8 leading-relaxed">
          El simulador real y las prácticas por tema son exclusivos para
          miembros PRO. ¡Prepárate con todo para tu examen!
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={onGoToBilling}
            className="w-full py-4 bg-blue-600 text-white rounded-2xl font-black hover:bg-blue-700 transition-all shadow-lg shadow-blue-200"
          >
            VER PLAN PREMIUM
          </button>

          <button
            onClick={onClose}
            className="w-full py-3 text-slate-400 font-bold hover:text-slate-600 transition-all"
          >
            Quizás más tarde
          </button>
        </div>
      </div>
    </div>
  );
};

export default PremiumModal;
